interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  const baseBtn =
    "min-w-9 h-9 px-3 rounded-md text-sm font-label flex items-center justify-center transition-colors cursor-pointer border";

  return (
    <nav aria-label="分页" className="flex items-center justify-center gap-2 mt-10 flex-wrap">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`${baseBtn} ${
            page === current
              ? "bg-accent-500 border-accent-500 text-background-50"
              : "border-background-200 text-foreground-600 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}